/* loaded by smart-asset */
export default require("./assets/capture-product.i.svg")